import { parseVersionedTranslations } from './utils/currency-display-translations';
import { getLanguageFromPath, DEFAULT_LANGUAGE } from './utils/languages';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

// Custom language detector that checks URL first
const urlLanguageDetector = {
  type: 'languageDetector' as const,
  name: 'urlLanguageDetector',
  detect(): string | undefined {
    if (typeof window !== 'undefined') {
      const langFromPath = getLanguageFromPath(window.location.pathname);
      if (langFromPath) {
        return langFromPath;
      }
    }
    return undefined;
  },
  cacheUserLanguage(): void {
    // No caching needed for URL-based detection
  },
};

void i18n
  .use(HttpBackend) // Load translations via HTTP
  .use(urlLanguageDetector) // Custom URL-based language detector (priority)
  .use(LanguageDetector) // Browser language detector (fallback)
  .use(initReactI18next) // Bind i18n to React
  .init({
    fallbackLng: DEFAULT_LANGUAGE,
    debug: false,
    interpolation: {
      escapeValue: false, // React already escapes
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Path to your translation files
      parse: parseVersionedTranslations,
    },
    detection: {
      order: ['urlLanguageDetector', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    supportedLngs: [
      'ae',
      'al',
      'ao',
      'ar',
      'at',
      'au',
      'bd',
      'be',
      'bg',
      'bh',
      'bo',
      'br',
      'bs',
      'by',
      'ca',
      'cd',
      'ch',
      'ci',
      'cl',
      'cm',
      'cn',
      'co',
      'cr',
      'cy',
      'cz',
      'de',
      'dk',
      'do',
      'dz',
      'ec',
      'ee',
      'eg',
      'en',
      'es',
      'et',
      'fi',
      'fr',
      'gb',
      'ge',
      'gh',
      'gr',
      'gt',
      'hk',
      'hn',
      'hr',
      'hu',
      'id',
      'ie',
      'il',
      'in',
      'iq',
      'is',
      'it',
      'jm',
      'jo',
      'jp',
      'ke',
      'kr',
      'kw',
      'kz',
      'lt',
      'lu',
      'lv',
      'ma',
      'md',
      'mk',
      'mt',
      'mx',
      'my',
      'na',
      'ne',
      'ng',
      'ni',
      'nl',
      'no',
      'nz',
      'om',
      'pa',
      'pe',
      'ph',
      'pk',
      'pl',
      'pr',
      'ps',
      'pt',
      'py',
      'qa',
      'ro',
      'rs',
      'ru',
      'sa',
      'se',
      'sg',
      'si',
      'sk',
      'sn',
      'sv',
      'th',
      'tn',
      'tr',
      'tw',
      'tz',
      'ua',
      'ug',
      'us',
      'uy',
      'vn',
      'za',
    ],
  });

export default i18n;
